const paymentMethods = {
  FREE: "free",
  SUBSCRIPTION: "Subscription",
  TIME_BASED_UNLIMITED_ACCESS: "TimeBasedUnlimitedAccess",
};

export default paymentMethods;



// WEBPACK FOOTER //
// ./src/common/subscriptionmanagement/paymentMethods.js